import { useState } from 'react'

export const useInputChange = (inititalObject) => {
    const [input, setInput] = useState(inititalObject)

    const handleInputChange = (e) => {
        

        setInput({
        ...input,
        [e.currentTarget.name]: e.currentTarget.value
    })
}
   
  
    const handleSwitchChange = (name) => {
        setInput({
            ...input,
            [name]: !input[name]
        });
    }
    return [input, handleInputChange, handleSwitchChange, setInput]
}